import m from "mithril";
import i18n from "../../../shared/i18n/i18n";
import Component_Unit_Scorm_Settings from "./component_unit_scorm_settings";
import Component_Unit_Scorm_Preview from "./component_unit_scorm_preview";
import Unit_Courses from "../unit_courses";

let loading = false;
let tab = "settings";
let unit = null;


const Page_Unit_Scorm = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
        tab = "settings";
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section with-menu", [
                        m("h1", i18n.t("interactive_unit")),
                        m(".toolbar-menu", [
                            m("div", {
                                class: tab === "preview" ? "active" : "", onclick: function () {
                                    tab = "preview";
                                }
                            }, i18n.t("preview")),
                            m("div", {
                                class: tab === "settings" ? "active" : "", onclick: function () {
                                    tab = "settings";
                                }
                            }, i18n.t("settings")),
                            m("div", {
                                class: tab === "courses" ? "active" : "", onclick: function () {
                                    tab = "courses";
                                }
                            }, i18n.t("courses"))
                        ])
                    ])
                ])
            ]),
            !loading ? [
                unit ? [
                    tab === "settings" ? m(Component_Unit_Scorm_Settings, {unit: unit.properties, onCoursesClick: function() { tab = "courses"; }})
                        : tab === "preview" ? m(Component_Unit_Scorm_Preview, {unit: unit.properties})
                            : tab === "courses" ? m(Unit_Courses, {unitId: unit.properties.id})
                                : ""
                ] : m(".text-gray padding", i18n.t("unable_to_load_unit"))
            ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
};
export default Page_Unit_Scorm;
